var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1543,
    cy: 20.2861,
    r: 20,
    fill: "#F1FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1543 15.582V18.4",
    stroke: "#21A1F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1713 11.8242C17.0571 11.8242 14.5353 14.346 14.5353 17.4602V19.2373C14.5353 19.8128 14.2983 20.676 14.0021 21.1668L12.9274 22.9608C12.2673 24.0694 12.7243 25.3049 13.9429 25.7111C17.988 27.0566 22.3631 27.0566 26.4081 25.7111C27.5505 25.3303 28.0414 23.9932 27.4236 22.9608L26.3489 21.1668C26.0527 20.676 25.8157 19.8043 25.8157 19.2373V17.4602C25.8073 14.363 23.2685 11.8242 20.1713 11.8242Z",
    stroke: "#21A1F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9719 26.0586C22.9719 27.6072 21.7026 28.8766 20.1539 28.8766C19.3839 28.8766 18.673 28.555 18.1653 28.0473C17.6575 27.5395 17.3359 26.8287 17.3359 26.0586",
    stroke: "#21A1F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.28e6b68ce934ec1ab682163337b4d3aa.svg";
export { ForwardRef as ReactComponent };